<template>
    <label class="form-switch"
           :class="{vertical: vertical_structure}" role="button">
        <input class="form-check-input"
               :type="get_type"
               :checked="checked"
               :name="radio_name"
               :disabled="disabled"
               @change="changeEvent"
               role="switch">
        <span v-show="placeholder" class="form-check-label">{{ placeholder }}</span>
    </label>
</template>

<script>
export default {
    name: "Switcher",
    props: {
        checked: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        item_id: {
            type: [String, Number],
            default: ''
        },
        radio_name: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        vertical_structure: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        get_type() {
            return !this.radio_name ? 'checkbox' : 'radio'
        }
    },
    methods: {
        changeEvent(event) {
            this.$emit('change', {
                target: event.target,
                checked: event.target.checked,
                id: this.item_id
            })
        }
    }
}
</script>
